import { render, staticRenderFns } from "./CreditorListListView.vue?vue&type=template&id=0b038208"
import script from "./CreditorListListView.vue?vue&type=script&lang=js"
export * from "./CreditorListListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b038208')) {
      api.createRecord('0b038208', component.options)
    } else {
      api.reload('0b038208', component.options)
    }
    module.hot.accept("./CreditorListListView.vue?vue&type=template&id=0b038208", function () {
      api.rerender('0b038208', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/creditorlist/CreditorListListView.vue"
export default component.exports